
export default function TrustSystemSection() {
  return (
    <section className="py-20 bg-white">
      <div className="mx-auto px-6 lg:px-[15%]">
        <div className="text-center mb-16">
          <h2 className="text-lg sm:text-xl lg:text-2xl xl:text-4xl font-bold text-[#663333] mb-4">
            三真承诺体系
          </h2>
          <p className="text-xs sm:text-sm lg:text-lg text-gray-600 max-w-2xl mx-auto">
            以科学的标准化体系，为每一位茶友提供可信赖的年份茶品质保障
          </p>
          <div className="w-24 h-1 bg-[#cc9966] mx-auto mt-6"></div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
          {/* 真产地 */}
          <div className="bg-[#f8f6f3] rounded-3xl p-10 hover:shadow-2xl transition-all duration-500 border border-[#cc9966]/20">
            <div className="text-center mb-8">
              <div className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 flex items-center justify-center bg-[#cc9966] rounded-full mx-auto mb-6 shadow-lg">
                <i className="ri-map-pin-fill text-lg sm:text-xl md:text-2xl text-white"></i>
              </div>
              <h3 className="text-lg sm:text-xl lg:text-2xl xl:text-3xl font-bold text-[#663333] mb-3">真产地</h3>
              <p className="text-[#cc9966] font-semibold text-sm sm:text-base lg:text-lg">云南核心产区溯源</p>
            </div>
            
            <div className="space-y-5">
              <div className="flex items-start space-x-4">
                <div className="w-3 h-3 bg-[#cc9966] rounded-full flex-shrink-0 mt-2"></div>
                <div>
                  <h4 className="font-semibold text-[#663333] mb-1 text-xs sm:text-sm">六大茶山核心产区</h4>
                  <p className="text-xs sm:text-sm text-gray-600">深入易武、布朗、南糯等知名茶区</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="w-3 h-3 bg-[#cc9966] rounded-full flex-shrink-0 mt-2"></div>
                <div>
                  <h4 className="font-semibold text-[#663333] mb-1 text-xs sm:text-sm">500+合作伙伴</h4>
                  <p className="text-xs sm:text-sm text-gray-600">源头仓储及厂家直接合作</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="w-3 h-3 bg-[#cc9966] rounded-full flex-shrink-0 mt-2"></div>
                <div>
                  <h4 className="font-semibold text-[#663333] mb-1 text-xs sm:text-sm">智能化仓储</h4>
                  <p className="text-xs sm:text-sm text-gray-600">3个20,000平标准酵藏仓</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="w-3 h-3 bg-[#cc9966] rounded-full flex-shrink-0 mt-2"></div>
                <div>
                  <h4 className="font-semibold text-[#663333] mb-1 text-xs sm:text-sm">专业审评团队</h4>
                  <p className="text-xs sm:text-sm text-gray-600">18位藏茶专家严苛把关</p>
                </div>
              </div>
            </div>
            
            <div className="mt-8 p-6 bg-white rounded-xl border-l-4 border-[#cc9966]">
              <p className="text-[#663333] font-medium text-xs sm:text-sm">
                每一片茶叶都有明确的产地身份证，确保原产地100%正宗性
              </p>
            </div>
          </div>

          {/* 真年份 */}
          <div className="bg-[#f8f6f3] rounded-3xl p-10 hover:shadow-2xl transition-all duration-500 border border-[#cc9966]/20">
            <div className="text-center mb-8">
              <div className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 flex items-center justify-center bg-[#cc9966] rounded-full mx-auto mb-6 shadow-lg">
                <i className="ri-time-fill text-lg sm:text-xl md:text-2xl text-white"></i>
              </div>
              <h3 className="text-lg sm:text-xl lg:text-2xl xl:text-3xl font-bold text-[#663333] mb-3">真年份</h3>
              <p className="text-[#cc9966] font-semibold text-sm sm:text-base lg:text-lg">证据链全程可追溯</p>
            </div>
            
            <div className="space-y-5">
              <div className="flex items-start space-x-4">
                <div className="w-3 h-3 bg-[#cc9966] rounded-full flex-shrink-0 mt-2"></div>
                <div>
                  <h4 className="font-semibold text-[#663333] mb-1 text-xs sm:text-sm">制作时间档案</h4>
                  <p className="text-xs sm:text-sm text-gray-600">详细记录每批茶叶制作过程</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="w-3 h-3 bg-[#cc9966] rounded-full flex-shrink-0 mt-2"></div>
                <div>
                  <h4 className="font-semibold text-[#663333] mb-1 text-xs sm:text-sm">入库存储记录</h4>
                  <p className="text-xs sm:text-sm text-gray-600">完整的仓储时间轨迹</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="w-3 h-3 bg-[#cc9966] rounded-full flex-shrink-0 mt-2"></div>
                <div>
                  <h4 className="font-semibold text-[#663333] mb-1 text-xs sm:text-sm">年度检测报告</h4>
                  <p className="text-xs sm:text-sm text-gray-600">定期品质与转化监测</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="w-3 h-3 bg-[#cc9966] rounded-full flex-shrink-0 mt-2"></div>
                <div>
                  <h4 className="font-semibold text-[#663333] mb-1 text-xs sm:text-sm">区块链防伪</h4>
                  <p className="text-xs sm:text-sm text-gray-600">不可篡改的数字化溯源</p>
                </div>
              </div>
            </div>
            
            <div className="mt-8 p-6 bg-white rounded-xl border-l-4 border-[#cc9966]">
              <p className="text-[#663333] font-medium text-xs sm:text-sm">
                建立完整证据链条，让每一个年份都有据可查，杜绝虚假年份
              </p>
            </div>
          </div>

          {/* 真转化 */}
          <div className="bg-[#f8f6f3] rounded-3xl p-10 hover:shadow-2xl transition-all duration-500 border border-[#cc9966]/20">
            <div className="text-center mb-8">
              <div className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 flex items-center justify-center bg-[#cc9966] rounded-full mx-auto mb-6 shadow-lg">
                <i className="ri-flask-fill text-lg sm:text-xl md:text-2xl text-white"></i>
              </div>
              <h3 className="text-lg sm:text-xl lg:text-2xl xl:text-3xl font-bold text-[#663333] mb-3">真转化</h3>
              <p className="text-[#cc9966] font-semibold text-sm sm:text-base lg:text-lg">科学仓储管理体系</p>
            </div>
            
            <div className="space-y-5">
              <div className="flex items-start space-x-4">
                <div className="w-3 h-3 bg-[#cc9966] rounded-full flex-shrink-0 mt-2"></div>
                <div>
                  <h4 className="font-semibold text-[#663333] mb-1 text-xs sm:text-sm">专业仓库群</h4>
                  <p className="text-xs sm:text-sm text-gray-600">8,000㎡标准化存储空间</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="w-3 h-3 bg-[#cc9966] rounded-full flex-shrink-0 mt-2"></div>
                <div>
                  <h4 className="font-semibold text-[#663333] mb-1 text-xs sm:text-sm">恒温控制</h4>
                  <p className="text-xs sm:text-sm text-gray-600">22-28℃精确温度管理</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="w-3 h-3 bg-[#cc9966] rounded-full flex-shrink-0 mt-2"></div>
                <div>
                  <h4 className="font-semibold text-[#663333] mb-1 text-xs sm:text-sm">恒湿调节</h4>
                  <p className="text-xs sm:text-sm text-gray-600">60-70%科学湿度控制</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="w-3 h-3 bg-[#cc9966] rounded-full flex-shrink-0 mt-2"></div>
                <div>
                  <h4 className="font-semibold text-[#663333] mb-1 text-xs sm:text-sm">智能监控</h4>
                  <p className="text-xs sm:text-sm text-gray-600">24小时全天候环境监测</p>
                </div>
              </div>
            </div>
            
            <div className="mt-8 p-6 bg-white rounded-xl border-l-4 border-[#cc9966]">
              <p className="text-[#663333] font-medium text-xs sm:text-sm">
                科学的仓储环境配置，确保茶叶在最佳条件下完美自然转化
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
